import * as React from 'react';
import { PublishButtonContainer } from '../PublishButton';
import { SaveDraftButtonContainer } from '../SaveDraftButton';
import * as styles from './HiddenBase.mobile.css';

export const HiddenBaseMobile = () => {
  return (
    <>
      <SaveDraftButtonContainer />

      <div className={styles['publish_button']}>
        <PublishButtonContainer />
      </div>
    </>
  );
};
